import { render, staticRenderFns } from "./ManageLocaleString.vue?vue&type=template&id=12111c40&"
import script from "./ManageLocaleString.vue?vue&type=script&lang=js&"
export * from "./ManageLocaleString.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports